import { render } from "./WarnRuleList.vue?vue&type=template&id=5a790370&scoped=true"
import script from "./WarnRuleList.vue?vue&type=script&lang=js"
export * from "./WarnRuleList.vue?vue&type=script&lang=js"

import "./WarnRuleList.vue?vue&type=style&index=0&id=5a790370&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a790370"],['__file',"src/views/h5/common/stock/warnRule/WarnRuleList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a790370"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a790370', __exports__)) {
    api.reload('5a790370', __exports__)
  }
  
  module.hot.accept("./WarnRuleList.vue?vue&type=template&id=5a790370&scoped=true", () => {
    api.rerender('5a790370', render)
  })

}


export default __exports__